/* Original Renegade v40 — collection/search facet behaviour. */
(function(){
  'use strict';
  document.querySelectorAll('[data-or-facets]').forEach(function(shell){
    if(shell.dataset.orFacetsReady==='1')return;
    shell.dataset.orFacetsReady='1';
    shell.dataset.orFocusManaged='1';

    var mobile=window.matchMedia('(max-width:900px)');
    var home=shell.parentNode;
    var marker=document.createComment('or-facets-home');
    var page=shell.closest('.collection-page');
    var controls=page&&page.querySelector('.or-collection-controls');
    var sort=controls&&(controls.querySelector('.or-collection-sort-form')||controls.querySelector('.or-collection-sort'));
    var toggle=shell.querySelector('.or-facets-toggle');
    var body=shell.querySelector('[data-facets-dialog]')||shell.querySelector('.or-facets__body');
    var lastFocus=null;

    home.insertBefore(marker,shell);

    function focusable(){
      if(!body)return[];
      return Array.prototype.slice.call(body.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')).filter(function(node){return node.offsetParent!==null});
    }
    function setDialogState(active){
      if(!body)return;
      if(active){
        body.setAttribute('role','dialog');
        body.setAttribute('aria-modal','true');
      }else{
        body.removeAttribute('role');
        body.removeAttribute('aria-modal');
      }
    }
    function close(){shell.open=false}
    function place(){
      if(mobile.matches){
        if(controls&&shell.parentNode!==controls)controls.insertBefore(shell,sort||null);
        close();
        setDialogState(false);
        document.body.classList.remove('or-facets-open');
      }else{
        if(marker.parentNode&&shell.parentNode!==marker.parentNode)marker.parentNode.insertBefore(shell,marker.nextSibling);
        close();
        setDialogState(false);
        document.body.classList.remove('or-facets-open');
      }
    }

    if(toggle)toggle.addEventListener('click',function(){if(!shell.open)lastFocus=toggle});
    shell.querySelectorAll('[data-facets-close]').forEach(function(button){button.addEventListener('click',function(event){event.preventDefault();close()})});
    shell.addEventListener('toggle',function(){
      var openMobile=mobile.matches&&shell.open;
      document.body.classList.toggle('or-facets-open',openMobile);
      setDialogState(openMobile);
      if(openMobile){
        window.requestAnimationFrame(function(){var closeButton=body&&body.querySelector('.or-facets__close');if(closeButton)closeButton.focus()});
      }else if(mobile.matches&&lastFocus&&document.contains(lastFocus)){
        window.requestAnimationFrame(function(){try{lastFocus.focus({preventScroll:true})}catch(error){lastFocus.focus()}});
      }
    });
    document.addEventListener('keydown',function(event){
      if(!mobile.matches||!shell.open)return;
      if(event.key==='Escape'){event.preventDefault();close();return}
      if(event.key!=='Tab')return;
      var items=focusable();if(!items.length)return;
      var first=items[0],last=items[items.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
    });
    if(mobile.addEventListener)mobile.addEventListener('change',place);else if(mobile.addListener)mobile.addListener(place);
    place();
  });
})();
